$(document).ready(function() {
  CheckForDupeCodes();
 })

function CheckForDupeCodes()
{
    var dt = document.getElementsByTagName('dt');
	var dd = document.getElementsByTagName('dd');
	
	const oc = [];
    var ocIndex = 0;
 
    const deadline = [];
    var deadlineIndex = 0;
	 
    for(var i = 0; i < dt.length; i++) 
	{
		if (dt[i].innerText.toUpperCase().includes("ORG CODE:"))
		{ 
			oc[ocIndex] = dd[i].innerText.trim().toUpperCase();
			ocIndex ++;
		}
	}

	var ocCount = new Set(oc).size;
	if(ocCount > 1)
	{
		DisableCheckOut();
        ShowOrgWarning();
	}
	else
	{
		EnableCheckOut();
        HideOrgWarning();
       // IF CART DOES CONTAIN ORDERS FOR A SINGLE SCHOOL THEN CHECK DEADLINE DATES OF CODES
       // THIS IS TO WORK AROUND ISSUES WITH THE CART COOKIE NOT EXPIRING FOR 14 DAYS

        CheckDeadLineDate();
	}
}

function EnableCheckOut()
{
    const checkout = document.getElementById('checkout');
    if(checkout)
        checkout.style.visibility = 'inline';
  
    const dCheckout = document.getElementById('dynamic-checkout-cart');
    if(dCheckout)
      dCheckout.style.visibility = 'inline';
}

function DisableCheckOut()
{
    const checkout = document.getElementById('checkout');
    if(checkout)
        checkout.style.visibility = 'hidden';
  
    const dCheckout = document.getElementById('dynamic-checkout-cart');
    if(dCheckout)
      dCheckout.style.visibility = 'hidden';
}

function ShowOrgWarning()
{
    const warning = document.getElementById('org-warning');
    if(warning)
      warning.style.display = 'inline';
}

function HideOrgWarning()
{
    const warning = document.getElementById('org-warning');
    if(warning)
      warning.style.display = 'none';
}

function ShowDeadlineWarning()
{
    const warning = document.getElementById('deadline-warning');
    if(warning)
      warning.style.display = 'inline';
}

function HideDeadlineWarning()
{
    const warning = document.getElementById('deadline-warning');
    if(warning)
      warning.style.display = 'none';
}


function CheckDeadLineDate()
{
    var dt = document.getElementsByTagName('dt');
	var dd = document.getElementsByTagName('dd');
    var orgCode = '';
    var designCode = '';

    for(var i = 0; i < dt.length; i++) 
	{              
        if (dt[i].innerText.toUpperCase().includes("ORG CODE:"))
        { 
            orgCode = dd[i].innerText.toUpperCase();
        }
  
        if (dt[i].innerText.toUpperCase().includes("DESIGN CODE:"))
		{ 
			designCode = dd[i].innerText.toUpperCase();
		}

        if(orgCode != '' && designCode != '')
        {
          
          CartValidationChecks(orgCode, designCode);
         
          if(DeadLineDateValid == true)
          {
            // alert('cart valid');
            EnableCheckOut();
            HideDeadlineWarning();
          }
          else
          {
            // alert('cart is invalid');
            DisableCheckOut();
            ShowDeadlineWarning();
            process.stop();
          }
          
          orgCode = '';
          designCode = '';
        }

	}
}

var DeadLineDateValid;

function isDevelopmentSite() {
  return document.location.host.indexOf("devshop.classfundraising.co.uk") > -1;
}

function CartValidationChecks(ocode, acode) {

    var domain = "cfrdataservices.agcontroltower.com";
    if (isDevelopmentSite())
      domain = "devcfrdataservices.agcontroltower.com";

    return new Promise((resolve) => {
        $.ajax({
            url: "https://" + domain + "/validate.asmx/ShopifyCart_HasDeadLineDatePast",
            data: "{'orgCode': '" + ocode + "', 'artworkCode' : '" + acode + "'}",
            dataType: "json",
            type: "POST",
            contentType: "application/json; charset=utf-8",
            async: false,
            success: function (data) {
                $(data).each(function (index, data) {
                    if (data.d != '') {
                       DeadLineDateValid = data.d.IsValid;
                    }
                });
            },
            error: function () { alert("No data found."); }
        });
    });
}
